// removed by extract-text-webpack-plugin
module.exports = {"root":"CentricUI__internal__FilterCheckbox__root","name":"CentricUI__internal__FilterCheckbox__name","count":"CentricUI__internal__FilterCheckbox__count","hex":"CentricUI__internal__FilterCheckbox__hex","image":"CentricUI__internal__FilterCheckbox__image","placeholder":"CentricUI__internal__FilterCheckbox__placeholder","checkboxIndicator":"CentricUI__internal__FilterCheckbox__checkboxIndicator","highlighter":"CentricUI__internal__FilterCheckbox__highlighter"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/catalog/internal/filters/components/internal/FilterCheckbox.css
// module id = 995
// module chunks = 10